export default __webpack_public_path__ + "static/media/info-main-md.4ca4ea47.jpg";